<template lang="pug">
    div
        div.from
            v-menu(
                ref="menuFrom"
                v-model="menuFrom"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
            )
                template(v-slot:activator="{ on }")
                    div.moreWrapper(v-on="on")
                        div.content
                            div.name {{ startDateLabel }}
                            div.date.dateFrom {{ startDate | formattedDate }}
                        div.icon
                            v-icon.moreIcon expand_more

                v-date-picker(
                    v-model="dateStart"
                    :min="currentDay"
                    :max="endDate"
                    scrollable
                    no-title
                    color="primary"
                )
                    div.controls
                        button-component(
                            :action="rangeSubmit"
                            color="primary"
                            flat
                            small
                        ) {{ $t('defaultButtons.ok') }}
        div.to
            v-menu(
                ref="menuTo"
                v-model="menuTo"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
            )
                template(v-slot:activator="{ on }")
                    div.moreWrapper(v-on="on")
                        div.content
                            div.name {{ endDateLabel }}
                            div.date.dateFrom {{ endDate | formattedDate }}
                        div.icon
                            v-icon.moreIcon expand_more

                v-date-picker(
                    v-model="dateEnd"
                    :min="dateStart"
                    scrollable
                    no-title
                    color="primary"
                )
                    div.controls
                        button-component(
                            :action="rangeSubmit"
                            color="primary"
                            flat
                            small
                        ) {{ $t('defaultButtons.ok') }}
</template>

<script>
    import VueTypes from 'vue-types';
    import Button from '../Button';
    import formattedDate from '~filters/FormattedDate';
    import dayjs from 'dayjs';

    export default {
        components: {
            ButtonComponent: Button
        },
        filters: {
            formattedDate
        },
        props: {
            startDateLabel: VueTypes.string.def('Date From'),
            endDateLabel: VueTypes.string.def('Date To'),
            startDate: VueTypes.string.def(''),
            endDate: VueTypes.string.def(''),
            rangeCallback: VueTypes.func.def(() => {})
        },
        data() {
            return {
                menuFrom: false,
                menuTo: false,
                currentDay: dayjs().format('YYYY-MM-DD'),
                dateStart: dayjs(this.startDate).format('YYYY-MM-DD'),
                dateEnd: dayjs(this.endDate).format('YYYY-MM-DD')
            };
        },
        methods: {
            rangeSubmit() {
                if (this.dateStart && this.dateEnd) {
                    this.rangeCallback({
                        from: this.dateStart,
                        to: this.dateEnd
                    });
                }

                this.menuFrom = false;
                this.menuTo = false;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .from
    .to
        display: inline-block;

    .from
        margin-right: 20px

    .moreWrapper
        display: flex
        cursor: pointer
        width: 115px

    .content
        padding-right: 15px

    .moreIcon
        background-color: rgba(249, 249, 249, 0.2);
        border-radius: 50%
        font-size: 22px
        color: $theme.white

    .name
        font-weight: 700
        font-size: 16px

    .date
        font-size: remify(14px)

    .controls
        width: 100%
        text-align: right

    >>>a
        &.v-list__tile--link
            &:hover,
            & > .isActive
                background: transparent !important
                color: $theme.action
</style>
